import axios from 'axios';
import { apiProfilesForProfileUrl } from '../config';

/**
 * PUT Profile.
 *
 * @author Yves Matta <yves.matta@qochealth.com>
 * @param {{}} props - properties Object
 * @param {{}} [props.requestConfig] - additional config for request
 * @param {Profile} [props.profile] - profile object
 * @returns {Promise}
 */
const putProfile = props => {
  const { profile, requestConfig } = props;

  const { profileUUID, ...otherProfileProps } = profile;
  const method = 'put';
  const url = apiProfilesForProfileUrl.replace(/{profileUUID}/g, profileUUID);

  return axios({
    data: otherProfileProps,
    method,
    url,
    ...requestConfig
  });
};

export default putProfile;



// WEBPACK FOOTER //
// ./src/qoc-sdk/library/putProfile.js